<div class="ap-display-flex ap-justify-content-end">
    <ap-icon [name]="isMessagePending() ? 'clock' : 'checkmark'" [size]="'small'" color="disabled"></ap-icon>
</div>
